import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { PlayingState } from '../types/instance';

export const useOnPlayingStateChanged = (
    onPlayingStateChanged: (playingState: PlayingState | undefined) => void
) => {
    useInstanceEffect(
        (instance) => instance.onPlayingStateChange(onPlayingStateChanged),
        [onPlayingStateChanged]
    );
};
